import React from "react";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../firebase";
import { Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const ProfilePage = () => {
  const [user, isLoading] = useAuthState(auth);
  const navigate = useNavigate();
  if (isLoading) {
    return <isLoading />;
  }

  return (
    <motion.Container
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      maxWidth="md"
      className="min-h-screen flex items-center justify-center bg-gray-900"
    >
      <Paper
        elevation={3}
        style={{ padding: "40px", backgroundColor: "#1f1f1f" }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            color: "#ffffff",
          }}
        >
          <Avatar
            sx={{ width: 120, height: 120, mb: 3 }}
            src={user.photoURL}
            alt={user.displayName}
          />

          <Typography sx={{ mb: 1 }} variant="h5">
            {user.displayName}
          </Typography>

          <Typography sx={{ mb: 3, color: "#b3b3b3" }} variant="subtitle1">
            {user.email}
          </Typography>

          <Button
            variant="contained"
            color="primary"
            style={{ backgroundColor: "#3b5998" }}
            onClick={() => console.log("Edit Profile Clicked!")}
          >
            Edit Profile [Not active yet]
          </Button>
          <Button
            variant="contained"
            color="primary"
            style={{ backgroundColor: "#3b5998", marginTop: "10px" }}
            onClick={() => navigate("/")}
          >
            Home Page
          </Button>
        </Box>
      </Paper>
    </motion.Container>
  );
};

export default ProfilePage;
